// extracted by mini-css-extract-plugin
export default {"pieChartWrapper":"Pie_pieChartWrapper__AnDTY","pieChartContent":"Pie_pieChartContent__21FkZ","title":"Pie_title__9EPSL"};